import { useDarkModeToggle } from '../../hooks/useDarkModeToggle'
import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { SettingsGroup } from '@/features/settings'

import { SettingsToggleRow } from './SettingsToggleRow'

export const DarkModeSection = () => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const { isDarkMode, toggleDarkMode } = useDarkModeToggle()

  return (
    <SettingsGroup
      colorScheme={colorScheme}
      title={t('settings:rebrand_account_display_group_title')}
    >
      <SettingsToggleRow
        colorScheme={colorScheme}
        dataTestId='dark-mode-toggle'
        isOn={isDarkMode}
        label={t('settings:rebrand_account_dark_mode_label')}
        onChange={(nextIsOn) => toggleDarkMode(nextIsOn)}
      />
    </SettingsGroup>
  )
}
